// store.ts / store.js
import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import { createBrowserHistory } from 'history';
import { createReduxHistoryContext } from 'redux-first-history';

import api from './middleware/api';
import cTaskAnswer from './middleware/cTaskAnswer';

import createRootReducer from './reducer';

// Создаём context
const { createReduxHistory, routerMiddleware, routerReducer } =
    createReduxHistoryContext({ history: createBrowserHistory() });

// Собираем middleware (routerMiddleware уже «привязан», не требует аргументов)
const enhancer = applyMiddleware(thunk, routerMiddleware, api, cTaskAnswer);
const composeEnhancers = composeWithDevTools({ trace: true, traceLimit: 25 });

// Создаём стор, добавляя routerReducer в корневой редьюсер
const store = createStore(createRootReducer(routerReducer), composeEnhancers(enhancer));

// Экспортируем history для роутера
export const history = createReduxHistory(store);

export default store;
